// extracted by mini-css-extract-plugin
module.exports = {"header":"styles-module--header--1c6u6","imageWrapper":"styles-module--imageWrapper--1D0MC","image":"styles-module--image--1O3Ii"};